var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"align":"stretch"}},_vm._l((_vm.values
        .filter(i => !i.secret || _vm.showSecret)
        .filter(i => _vm.haveAccess(i))),function(card,index){return _c('v-col',{key:'card-' + index,attrs:{"cols":"12","md":"3"}},[_c('menu-card',{attrs:{"title":card.title,"icon":card.icon,"description":card.description,"color":card.color,"to":card.to,"commingSoon":card.commingSoon,"in-development":card.inDevelopment,"directory":""}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }